module.exports = __webpack_public_path__ + "img/IMG_1024_L_BlackMatted_MockedUp.d0eeb85b.jpg";